<template>
  <div class="container">
    <div class="table-header">
      <h1>Invoices</h1>
    </div>

  <Suspense>
    <template #default>
      <InvoicesTable></InvoicesTable>
    </template>
    <template #fallback>
      invoices table still loading...
    </template>
  </Suspense>

  </div>
</template>

<script setup lang="ts">
import InvoicesTable from './Invoices-table.vue'
</script>
